export const SCREENINGS_TOP_OFFSET = 95

export const SEARCH_BAR_HEIGHT = 62

export const HEADER_LOGO_CONTAINER_HEIGHT = 98
